/**
 * @param {string} email
 * @returns Boolean
 * @description Проверяет являться ли переданная строка адресом email
 */
export function validateEmail(email) {
    const regex = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;
    return regex.test(email);
}
